"use client";

import { MainLink, TitleH3 } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const IndividualOption = () => {
  const tH = useTranslations("floorPlanDesigns.individualOpt");
  const tC = useTranslations("common");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column w-full py-16">
        <div className="flex flex-col gap-5">
          <TitleH3 title={tH("title")} />
          <div className="text-ring flex flex-col gap-1">
            <p>{tH("text")}</p>
            <p>{tH("text1")}</p>
            <p>{tH("text2")}</p>
            <p>{tH("text3")}</p>
          </div>

          <div className="flex">
            <MainLink
              href={"/individuelle-grundrisse"}
              title={tC("individual")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualOption;
